module.exports = __webpack_public_path__ + "img/room_DF.a0de58c4.png";